import { Map as ImmutableMap } from 'immutable';
import { createAction } from 'redux-actions';

import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';

// import { ImportModalComponent } from 'components/RootModal/modalRegistry';

export const INVOICE_PAYMENT_ROOTUI_TYPE = 'INVOICE_PAYMENT_CONTAINER';
// RegisterModalComponent(INVOICE_PAYMENT_ROOTUI_TYPE, InvoicePaymentFormContainer);

// ImportModalComponent(INVOICE_PAYMENT_ROOTUI_TYPE, () => import('./index'));

// const Component = lazy(() => retryPromise(() => import('./index')));
// RegisterModalComponent(INVOICE_PAYMENT_ROOTUI_TYPE, Component);

// @ts-expect-error FIXME TS7006
export const InvoicePaymentUpsertAction = createAction(rootUiActions.createDialog.toString(), (props) =>
  rootUiTypes.mkRootUiData({
    id: 'invoice-payment',
    type: INVOICE_PAYMENT_ROOTUI_TYPE,
    props: ImmutableMap({
      modalType: props.modalType || 'dialog',

      action: props.action,
      initIdType: props.initIdType,
      initId: props.initId,
      initSplitItemId: props.initSplitItemId,
      initScreen: props.initScreen,

      context: props.context,
    }),
  }),
);
